import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { Router } from '@angular/router';

import Swal from 'sweetalert2';

import { GlobalStorage } from 'src/app/global/storage';

import { ReceptionCloseService } from 'src/services';

import { Funeral } from 'src/models/Funeral';

import { StepType } from 'src/types';
import { BundleCartService, BundleType } from '../../../../services/bundle-cart.service';

@Component({
  selector: 'app-flowers-home',
  templateUrl: './flowers-home.component.html',
  styleUrls: ['./flowers-home.component.scss'],
  animations: [
    trigger('inOutAnimation', [
      transition(':enter', [style({ opacity: 0 }), animate('1s ease-out', style({ opacity: 1 }))]),
      transition(':leave', [style({ opacity: 1 }), animate('1s ease-in', style({ opacity: 0 }))]),
    ]),
  ],
})
export class FlowersHomeComponent implements OnInit {
  @Output()
  OnNextScreen: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private storage: GlobalStorage,
    private route: Router,
    private closeService: ReceptionCloseService,
    private bundleCartService: BundleCartService
  ) {}

  Funeral: Funeral;
  funeralCloseDateTime: Date;
  isFuneralClosed: boolean;
  displaySkipButton: boolean = false;

  ngOnInit(): void {
    this.bundleCartService.resetCurrentStep();
    this.Funeral = this.storage.Funeral;

    // funeral-closed
    const receptionStatus = this.closeService.getReceptionStatus(this.Funeral, StepType.Flower);
    this.funeralCloseDateTime = receptionStatus.funeralCloseDateTime;
    this.isFuneralClosed = receptionStatus.isFuneralClosed;

    this.bundleCartService.hasNextStep(StepType.Flower).then((hasNextStep) => {
      this.displaySkipButton = hasNextStep || !this.bundleCartService.isEmpty();
    });
  }

  async next(): Promise<void> {
    await this.bundleCartService.goToAdd(BundleType.Flower);
  }

  async skip(): Promise<void> {
    if (!this.displaySkipButton) {
      await Swal.fire({
        icon: 'error',
        title: 'お申込み内容確認画面に移動できません',
        text: '1点以上のお申込が必要です。',
      });
      return;
    }

    const order = this.storage.Order;
    order.FlowerOrder = null;
    order.FlowerPresent = null;
    this.storage.Order = order;

    const steps = this.storage.OrderSteps;
    steps.isFlowerStepCompleted = true;
    this.storage.OrderSteps = steps;

    await this.bundleCartService.goToNextStep(BundleType.Flower);
  }
}
